(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pack-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.pack-selector').forEach(function (selector) {
      var blockId = selector.dataset.blockId;
      var dataEl = document.getElementById('PackVariantData-' + blockId);
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var sectionId = data.sectionId;
      var variants = data.variants;
      var options = data.options;

      selector.querySelectorAll('.pack-selector__card').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.disabled) return;

          selector.querySelectorAll('.pack-selector__card').forEach(function (c) {
            c.classList.remove('selected');
          });

          card.classList.add('selected');

          var variantId = parseInt(card.dataset.variantId, 10);
          var variant = variants.find(function (v) { return v.id === variantId; });
          if (!variant) return;

          var variantSelects = document.getElementById('variant-selects-' + sectionId);
          if (!variantSelects) return;

          options.forEach(function (optionName, index) {
            var optionValue = variant.options[index];

            var radio = variantSelects.querySelector(
              'input[name="options[' + optionName + ']"][value="' + optionValue + '"]'
            );
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }

            var selects = variantSelects.querySelectorAll('select');
            if (selects[index]) {
              selects[index].value = optionValue;
              selects[index].dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          document.dispatchEvent(new CustomEvent('dessinou:variant-changed', {
            bubbles: true,
            detail: { price: variant.price, variantId: variantId }
          }));
        });
      });
    });
  }());
  } catch(e) { console.error(e); }
})();

})();
